import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "../components/terminal/Page";
import Journal from "../components/journal/Journal";
import ScoreAnalytics from "../components/analytics/ScoreAnalytics";
import T50ResearchLab from "../components/analytics/T50ResearchLab";
import LiveTradingTest from "../components/trading/LiveTradingTest";
import { useWorkspace } from "../context/WorkspaceContext";

export function JournalPage() {
  return (<div className="space-y-3" data-testid="page-journal"><PageHeader title="Trade Journal" subtitle="Closed trades from the execution engine — DEMO, PAPER and REPLAY are separated by the mode filter." /><Journal /></div>);
}

export function ScoreLabPage() {
  return (<div className="space-y-3" data-testid="page-score-lab"><PageHeader title="Score Lab" subtitle="Does the confluence score predict outcomes? Computed from real closed trades only (GET /api/analytics/confluence)." /><LabTabs /></div>);
}

// /demo-trade?symbol= — the existing Deriv DEMO trading system (one execution pathway, server-side safety layer).
export function DemoTradePage() {
  const [params] = useSearchParams();
  const { symbol } = useWorkspace();
  const sym = params.get("symbol") || symbol;
  return (<div className="space-y-3" data-testid="page-demo-trade"><PageHeader title="Deriv Demo Trading" subtitle={`${sym} · every execution passes the server-side safety layer (DEMO only)`} /><LiveTradingTest symbol={sym} /></div>);
}


function LabTabs() {
  const [tab, setTab] = React.useState("score");
  return (
    <div className="space-y-3">
      <div className="flex gap-1" data-testid="lab-tabs">
        {[["score", "Confluence Score"], ["t50", "T50 Research"]].map(([id, l]) => <button key={id} data-testid={`lab-tab-${id}`} onClick={() => setTab(id)} className={`h-8 px-3 rounded-md border text-xs font-semibold ${tab === id ? "border-primary bg-primary/15 text-primary" : "border-border text-muted-foreground hover:bg-secondary"}`}>{l}</button>)}
      </div>
      {tab === "score" ? <ScoreAnalytics /> : <T50ResearchLab />}
    </div>
  );
}
